import { Alert, Autocomplete, Stack } from '@mui/material'
import MDInput from 'components/MDInput'
import StepHeader from './StepHeader'
import { resolveCompanyOptions } from '../../data-organizers/announcements/resolveSendOptions'

export const COMPANY_LABEL = 'חברה'
export const COMPANY_HEADER = 'לאיזו חברה לשלוח את המודעה?'
export const COMPANY_NEXT_HINT = 'לחצו על הבא כדי לבחור את כתובות הדוא״ל של הנמענים'

export default function SendCompanyStep({
    companies,
    selectedCompanyId,
    onCompanySelected,
}) {
    const companyOptions = resolveCompanyOptions(companies)
    const optionIds = companyOptions.map((option) => option.id)
    const labelOf = (id) => companyOptions.find((option) => option.id === id)?.label ?? ''

    return (
        <Stack spacing={2}>
            <StepHeader>{COMPANY_HEADER}</StepHeader>

            {selectedCompanyId != null && (
                <Alert severity="info" data-testid="next-step-hint">{COMPANY_NEXT_HINT}</Alert>
            )}

            <Autocomplete
                options={optionIds}
                getOptionLabel={labelOf}
                value={selectedCompanyId}
                onChange={(event, id) => onCompanySelected?.(id)}
                renderInput={(params) => {
                    const inputProps = {
                        ...params.inputProps,
                        'data-testid': 'send-company-field',
                    }

                    return (
                        <MDInput
                            {...params}
                            inputProps={inputProps}
                            label={COMPANY_LABEL}
                            fullWidth
                        />
                    )
                }}
                renderOption={(props, id) => {
                    const { key, ...optionProps } = props
                    return (
                        <li key={key} {...optionProps} data-testid={`send-company-option-${id}`}>
                            {labelOf(id)}
                        </li>
                    )
                }}
            />
        </Stack>
    )
}
